const API_URL = process.env.REACT_APP_API_URL || 'https://api-pak.sudindikjt2.site';

function token() {
  return localStorage.getItem('token') || '';
}

async function request(path, options = {}) {
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token()}`
  };

  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers
  });

  const contentType = String(response.headers.get('content-type') || '');

  if (!response.ok) {
    let message = 'Permintaan gagal.';
    if (contentType.includes('application/json')) {
      const data = await response.json().catch(() => ({}));
      message = data.msg || data.message || message;
    } else {
      message = (await response.text()).slice(0, 500) || message;
    }
    throw new Error(message);
  }

  return response;
}

export async function getTteDocuments() {
  const res = await request('/api/tte/documents');
  return res.json();
}

export async function getMySigner() {
  const res = await request('/api/tte/me/signer');
  return res.json();
}

export async function getTteSigners() {
  const res = await request('/api/tte/signers');
  return res.json();
}

export async function saveTteSigner(payload) {
  const res = await request('/api/tte/signers', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  return res.json();
}

export async function uploadTteSource(pakId, file) {
  const form = new FormData();
  form.append('file', file);

  const res = await request(`/api/tte/documents/${pakId}/source`, {
    method: 'POST',
    body: form
  });

  return res.json();
}

export async function signTte(pakId, passphrase) {
  try {
    const res = await request(`/api/tte/documents/${pakId}/sign`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ passphrase })
    });
    return res.json();
  } finally {
    passphrase = '';
  }
}

export async function batchSignTte(pakIds, passphrase) {
  try {
    const res = await request('/api/tte/documents/batch-sign', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ pak_ids: pakIds, passphrase })
    });
    return res.json();
  } finally {
    passphrase = '';
  }
}

export async function getMyTteStatus() {
  const res = await request('/api/tte/my-status');
  return res.json();
}

export async function downloadSignedTte(pakId) {
  const res = await request(`/api/tte/documents/${pakId}/signed`);
  return res.blob();
}
